"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const ElasticMapper = (elasticResults, map) => {
    return elasticResults.hits.map((hit) => {
        let row = {};
        // If a map is passed in, use that, otherwise, just default to the row being the hit._source
        if (map) {
            (0, lodash_1.each)(map, (reducer, key) => {
                row[key] = reducer(hit._source, hit); // the second argument is the raw hit, which might include a .highlight attribute
            });
        }
        else {
            row = Object.assign(Object.assign({}, hit._source), { hit });
        }
        return row;
    });
};
exports.default = ElasticMapper;
